/**
 * Projeto público oficial usado como demonstração interativa.
 *
 * Fonte única para Home e Landing Pages de campanha.
 * Atualize `projectId` e `projectPath` quando o projeto demo for criado ou trocado.
 *
 * NÃO usar /embed comercial — a demo institucional usa fetch público + PanoramaViewer.
 */

export const FIVI360_DEMO_PROJECT = Object.freeze({
  portfolioSlug: "fivi360",
  projectId: "ovyUUESHqm7ag1SGhAb6",
  portfolioPath: "/u/fivi360",
  projectPath: "/share/project/ovyUUESHqm7ag1SGhAb6",
});
